import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useRouter } from 'next/router'
import { searchKeywordSchema } from '../../schemas/searchKeyword'

export interface SearchKeywordFormType {
  searchKeyword: string
  seq?: string
}

const useExamQuestionSearchKeywordForm = () => {
  const router = useRouter()

  const formMethods = useForm<SearchKeywordFormType>({
    resolver: yupResolver(searchKeywordSchema),
    mode: 'onChange',
    defaultValues: {
      searchKeyword: router.query.searchKeyword?.toString() ?? '',
      seq: router.query.seq?.toString() ?? '',
    },
  })

  return formMethods
}

export default useExamQuestionSearchKeywordForm
